import { api } from './client'
import type { ArticleMaterial } from './nomenclatoare'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Stocuri/WarehouseModels.cs ----------

export type ZoneType = 'Receptie' | 'DepozitareMateriiPrime' | 'ProductieWip' | 'ProduseFinite' | 'ExpeditieStaging' | 'Scrap' | 'Altele'

export interface LocationItem { id: string | null; code: string; name: string | null }

export interface ZoneItem {
  id: string | null
  code: string
  name: string
  type: ZoneType
  materialFilter: ArticleMaterial | null
  locations: LocationItem[]
}

export interface WarehouseListItem { id: string; code: string; name: string; workPointName: string; zoneCount: number; isActive: boolean }

export interface WarehouseDetail {
  id: string
  code: string
  name: string
  workPointId: string
  isActive: boolean
  zones: ZoneItem[]
}

export type SaveWarehousePayload = Omit<WarehouseDetail, 'id' | 'isActive'>

export interface WorkPointRef { id: string; code: string; name: string }

export const listWarehouses = () => api.get<WarehouseListItem[]>('/stocuri/depozite').then((r) => r.data)
export const listWarehouseWorkPoints = () => api.get<WorkPointRef[]>('/stocuri/depozite/puncte-lucru').then((r) => r.data)
export const getWarehouse = (id: string) => api.get<WarehouseDetail>(`/stocuri/depozite/${id}`).then((r) => r.data)

export const createWarehouse = (payload: SaveWarehousePayload) =>
  api.post<{ id: string }>('/stocuri/depozite', payload).then((r) => r.data)

export const updateWarehouse = (id: string, payload: SaveWarehousePayload) =>
  api.put(`/stocuri/depozite/${id}`, payload)

export const deactivateWarehouse = (id: string) => api.post(`/stocuri/depozite/${id}/deactivate`)
